import { useObrasToolbar } from "./use-obras-toolbar";
import { ObrasToolbarView } from "./view-obras-toolbar";
import type { ObrasToolbarProps } from "./types-obras-toolbar";

export function ObrasToolbar(props: ObrasToolbarProps) {
  const vm = useObrasToolbar(props);

  return <ObrasToolbarView {...vm} />;
}

export type * from "./types-obras-toolbar";
